<template>
  <div class="head-page">
      <!-- <span>SHOPPING</span> -->
      <div @click="toPath('/')" class="head-logo">
        <img src="@/assets/icon_logo.png" class="icon_logo"/>
      </div>
      <div class="flex-style">
           <div class="shopping"  @click="toPath('/shopping')">
                <img src="@/assets/icon_goumai.png" @click="isShow = false"/>
            </div>
           <div class="cart"  @click="toPath('/cart')" v-if="isEn()" >
                <img src="@/assets/cart.png"/>
           </div>
           <div class="about-us"  @click="isShow = true" v-if="isEn()" >
                <img src="@/assets/icon_guanyuwomen.png"/>
           </div>
          <!-- <img src="@/assets/icon_caidan.png" class="icon_caidan" @click="isShow = true" alt=""> -->
      </div>
      <div class="mask"  v-if="isShow"  @click="isShow = false" >
        <div class="menu">
            <div class="menu-main">
                <img src="@/assets/icon_guanbi.png" class="close"  @click="isShow = false"/>
                <div class="hover-content" v-if="token">
                    <p @click.stop="toPath('/myOrder')">{{$t('order')}}</p>
                    <p @click.stop="logout">{{$t('logout')}}</p>
                </div>
                <div class="hover-content" v-else>
                    <p @click.stop="toPath('/login')">{{$t('login')}}</p>
                    <p @click.stop="toPath('/register')">{{$t('register')}}</p>
                </div>
                
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import {isEn} from '@/utils/util'
export default {
 props:['token'],
 data () {
     return{
        isShow:false
     }
 },
 methods:{
     isEn,
     toPath (url) {
         this.isShow = false
         this.$router.push(url)
     },
     // 退出登录
    logout () {
        this.isShow = false
        localStorage.removeItem('token')
        this.$emit('isLogin')
        this.$router.replace('/')
    },
 }
}
</script>

<style lang='less' scoped>
    .head-page{
        height: 96px;
        background: #000000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;
        color: #fff;
        font-weight: bold;
        z-index: 99;
        .head-logo{
            height: 100%;
            width: 300px;
            display: flex;
            align-items: center;
            .icon_logo{
                height: 36px;
                width: 223px;
            }
        }
     
        .flex-style{
            display: flex;
            align-items: center;
            height: 100%;
        }
        .shopping{
            height: 100%;
            width: 80px;
            display: flex;
            align-items: center;
            // margin-right: 100px;
            justify-content: center;
            img{
                width: 40px;
                height: 44px;
            }
        }
        .cart{
            // margin-right: 100px;
            width: 90px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 50px;
                height: 40px;
            }
        }
        .about-us{
            width: 72px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                width: 36px;
                height: 42px;
            }
        }
        .icon_caidan{
            width: 38px;
            height: 36px;
        }
        .mask{
            position: fixed;
            height: 100%;
            width: 100%;
            background: rgba(0, 0, 0, 0.5);
            z-index: 1;
            left: 0;
            bottom: 0;
        }
        .menu{
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 2;
            background: #000000;
            display: flex;
            .menu-main{
                position: relative;
                display: flex;
                flex-flow: column wrap;
                justify-content: center;
                align-items: center;
                padding: 40px 0;
                flex: 1;
                .close{
                    position: absolute;
                    top: 46px;
                    right: 46px;
                    width: 28px;
                    height: 28px;
                }
                p{
                    margin-bottom: 60px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
    .hover-content{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/head.vue